import {IconButton} from '@material-ui/core';
import IPhoneLocationIcon from '@material-ui/icons/NearMe';
import IPhoneLocationOutlinedIcon from '@material-ui/icons/NearMeOutlined';
import AndroidLocationIcon from '@material-ui/icons/MyLocation';

import React, {MouseEventHandler} from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {isIOS} from '../utilities/ios-hacks';
import {useSelector} from 'react-redux';
import {getCurrentMapActionSelector} from '../store/mapControlSlice';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        locationIcon: {
            color: theme.palette.grey[500],
            backgroundColor: theme.palette.background.paper,
            padding: 10,

            '&:hover': {
                backgroundColor: theme.palette.background.paper,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.background.paper,
                },
            },
        },
        root: {
            marginRight: 8,
            marginBottom: 4,
        }
    }));

interface UserLocationButtonProps {
    onClick?: MouseEventHandler,
}

function UserLocationButton({onClick}: UserLocationButtonProps): JSX.Element {
    const classes = useStyles();

    const mapIsOnUserLocation = useSelector(getCurrentMapActionSelector)?.type === 'trackUserLocation';

    const TrackingLocationIcon = isIOS() ? IPhoneLocationIcon : AndroidLocationIcon;
    const NotTrackingLocationIcon = isIOS() ? IPhoneLocationOutlinedIcon : AndroidLocationIcon;

    const icon = mapIsOnUserLocation ? <TrackingLocationIcon color={'primary'}/> : <NotTrackingLocationIcon color={'secondary'}/>;

    return <div className={classes.root} onClick={onClick}>
        <IconButton aria-label="go to the user's location" size={'medium'} className={classes.locationIcon}>
            {icon}
        </IconButton>
    </div>;
}

export default UserLocationButton;